import newArrivals11 from '../images/arrivals/11.jpeg'
import newArrivals21 from '../images/arrivals/21.jpg'
import newArrivals31 from '../images/arrivals/31.jpeg'
import newArrivals41 from '../images/arrivals/41.jpg'
import newArrivals51 from '../images/arrivals/51.png'
import newArrivals61 from '../images/arrivals/61.png'
import newArrivals71 from '../images/arrivals/71.png'
import newArrivals81 from '../images/arrivals/81.png'
import newArrivals12 from '../images/arrivals/12.jpeg'
import newArrivals22 from '../images/arrivals/22.jpg'
import newArrivals32 from '../images/arrivals/32.png'
import newArrivals42 from '../images/arrivals/42.jpg'
import newArrivals52 from '../images/arrivals/52.png'
import newArrivals62 from '../images/arrivals/62.png'
import newArrivals72 from '../images/arrivals/72.png'
import newArrivals82 from '../images/arrivals/82.png'
import newArrivals92 from '../images/arrivals/92.png'
import newArrivals91 from '../images/arrivals/91.png'


export const newArrivalsData = [{
    image: newArrivals11,
    image1 : newArrivals12,
    category: "Studio Monitor Speakers",
    details : "Focal Alpha 80 Evo 8-inch Powered Studio Monitor, Pair",
    price : 175000.12,
    showQuickView: true
    

    
},
{
    image : newArrivals21,
    image1 : newArrivals22,
    category: "Studio Monitor Speakers",
    details : "Focal Alpha 65 Evo 6.5 inch Powered Studio Monitor, Pair",
    price : 145000.00,
    showQuickView: true
    

},
{
    image : newArrivals31,
    image1 : newArrivals32,
    category: "Studio Monitor Speakers",
    details : "Focal Alpha 50 Evo 5 inch Powered Studio Monitor, Pair",
    price : 115000.00,
    showQuickView: true
    

},
{
    image : newArrivals41,
    image1 : newArrivals42,
    category: "Studio Monitor Speakers",
    details: "PreSonus Eris E4.5 4.5 inch Powered Studio Monitors",
    price : 28500.00,
    showQuickView: true
    


},
{
    image : newArrivals51,
    image1 : newArrivals52,
    category : "Headphones",
    details : "Beyerdynamic DT 900 PRO X Studio Headphone",
    price : 36000.00,
    showQuickView: true
    

},
{
    image : newArrivals61,
    image1 : newArrivals62,
    category : "Microphones",
    details : "Beyerdynamic TG Drum Set PRO M Drum Microphone Set",
    price : 90000,
    showQuickView: true
    

},
{
    image : newArrivals71,
    image1 : newArrivals72,
    category : "Microphones",
    details :"Beyerdynamic TG D71 Condenser Boundary Microphone, Semi Cardioid",
    price: 30000.00,
    showQuickView: true
    

},
{
    image : newArrivals81,
    image1 : newArrivals82,
    category :"Microphones",
    details : "Beyerdynamic M 90 PRO X Cardiod Condenser Microphone",
    price: 41500.00,
    showQuickView: true
    

},
{
    image : newArrivals91,
    image1 : newArrivals92,
    category : "Microphones",
    details : "Beyerdynamic TG V35 s Dynamic Vocal Microphone",
    price: 8000.00,
    showQuickView: true
    

}]